import { SlickDataView } from "@slickgrid-universal/common";

/**
 * The row cache the patch below reads. It is `protected rows: TData[]` on `SlickDataView`, so a
 * prototype patch cannot reach it through the public type, and it stays optional here because the
 * patch also runs for an instance whose cache has not been built yet.
 */
interface DataViewRowCache {
  rows?: unknown[];
}

const originalMapRowsToIds = SlickDataView.prototype.mapRowsToIds;

// Fixes the paste crash in CUBE-FRONTEND-9QS: the original only checks `row < rows.length`, so a
// negative index or a hole in `rows` reaches `rowItem[idProperty]` and throws. `rowArray` is widened
// because the argument comes from grid/plugin event payloads, not from this codebase.
SlickDataView.prototype.mapRowsToIds = function (this: DataViewRowCache, rowArray: number[] | undefined) {
  return originalMapRowsToIds.call(
    this,
    (rowArray ?? []).filter((row) => this.rows?.[row] != null),
  );
};
